// Pagination

$(function () {

    $(document).on("click", ".page-link", function (e) {
        const $link = $(this);
        const href = $link.attr("href");
        const ajaxHref = $link.data("ajax-href");
        if (ajaxHref !== undefined && ajaxHref.length > 0) {
            const $target = $link.closest(".jsPaginationTarget");
            EUCUtils.reload(ajaxHref, $target, href);
            e.preventDefault();
        }
    });
})